// @flow
import React, { Component } from 'react';
import TutorialCard from './TutorialCard';


type Props = {
  image: string,
  title: string,
  pdf: () => string | void,
  page?: number,
};

export default class PdfTutorialCard extends Component<Props> {

  openPdf(pdfResolver: () => string | void) {
    const pdf = pdfResolver();
    if (!pdf) {
      return;
    }

    window.open(pdf);
  }

  openPDFAtPage(pdfResolver: () => string | void, page: number) {
    const pdf = pdfResolver();
    if (!pdf) {
      return;
    }

    window.open(pdf + '#page=' + page.toString());
  }

  render() {
    const { title, pdf, page, image } = this.props;

    let onClick = () => this.openPdf(pdf);

    if (page) {
      onClick = () => this.openPDFAtPage(pdf, page);
    }

    return (
      <TutorialCard title={title} onClick={onClick} image={image} />
    );
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/tutorials/components/PdfTutorialCard.js